import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Content from "./pages/Content";
import UserComponent from "./pages/Users/UserComponent";
import Transaction from "./pages/Transaction/Transaction";
import Login from "./pages/Login/Login";
import { jwtDecode } from "jwt-decode";
import SelectCompanyLogin from "./pages/SelectCompanyLogin/SelectCompanyLogin";
import Kyc from "./pages/Kyc/Kyc";
import Categories from "./pages/ExpenseCategories/ExpenseCategories";
import BulkUers from "./pages/Users/BulkUsers/BulkUsers";
import ExpenseSettings from "./pages/ExpenseSettings/ExpenseSettings";
import Insight from "./pages/Insights/Insight";
import ExpenseRecovery from "./pages/ExpenseRecovery/ExpenseRecovery";
import KycAndAcValidate from "./pages/KycAndAcValidate/KycAndAcValidate";
import AddUsers from "./pages/AddUsers/AddUsers";
import Notifications from "./pages/Notification/Notification";
import Statement from "./pages/Statement/Statement";
function App() {
  console.log("APP.js-----------------------------------");
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/selectCompany" element={<SelectCompanyLogin />} />
      <Route path="/content" element={<Content />}>
        <Route path="users" element={<UserComponent />} />
        <Route path="add-users" element={<AddUsers />} />
        <Route path="recovery" element={<ExpenseRecovery />} />
        <Route path="statement" element={<Statement/>} />
        <Route path="insights" element={<Insight />} />
        <Route path="bulkUser" element={<BulkUers />} />
        <Route path="transactions" element={<Transaction />}>
          <Route path="users" element={<UserComponent />} />
        </Route>
        <Route path="kyc" element={<Kyc />} />
        <Route path="categories" element={<Categories />} />
        <Route path="config" element={<ExpenseSettings />} />
        <Route path="kycValidation" element={<KycAndAcValidate />} />
        <Route path="Notifications" element={<Notifications />} />
      </Route>
    </Routes>
  );
}

export default App;
